import { useEffect } from 'react';
import { useTheme } from '@/context/ThemeContext';
import { useTenant } from '@/context/TenantContext';
import { updateThemeVariables } from '@/utils/themeUtils';

/**
 * Component that syncs branding colors when theme changes
 * This ensures brand colors are properly adjusted for light/dark mode
 */
export function ThemeBrandingSync() {
  const { theme } = useTheme();
  const { branding } = useTenant();

  useEffect(() => {
    if (branding) {
      // Re-apply branding colors when theme changes
      // The updateThemeVariables function will adjust colors based on current theme
      updateThemeVariables({
        primary_color: branding.primary_color,
        secondary_color: branding.secondary_color
      });
    }
  }, [theme, branding]);

  // Listen for OS theme changes when user has "system" theme selected
  useEffect(() => {
    if (theme !== 'system' || !branding) return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleSystemThemeChange = () => {
      // Re-apply branding colors when OS theme changes
      updateThemeVariables({
        primary_color: branding.primary_color,
        secondary_color: branding.secondary_color
      });
    };

    // Listen for changes
    mediaQuery.addEventListener('change', handleSystemThemeChange);

    return () => {
      mediaQuery.removeEventListener('change', handleSystemThemeChange);
    };
  }, [theme, branding]);

  // This component doesn't render anything
  return null;
}

